import { render, staticRenderFns } from "./JournalFilePreviewItem.vue?vue&type=template&id=f6ae33b4&scoped=true&"
import script from "./JournalFilePreviewItem.vue?vue&type=script&lang=ts&"
export * from "./JournalFilePreviewItem.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFilePreviewItem.vue?vue&type=style&index=0&id=f6ae33b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ae33b4",
  null
  
)

export default component.exports